import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import service from '@/services';
import { connectionErrorHandler } from '@/services/integrations/util';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { isEmptyString } from '@/utils/util';

import { CompoundConnectModal } from '../../components/ConnectModal';
import type { AtlasInfo } from '../types';

type Props = {
  onConnectComplete: (workspace: AtlasInfo) => void;
};

export const AtlasConnectModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState<string | null>(null);
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);

  const handleConnectWorkspace = async () => {
    if (!currWorkspace) return;
    try {
      const data = await service.atlas.createAtlasInfo(
        currWorkspace.alias,
        apiKey,
      );
      props.onConnectComplete(data);
      closeModal();
    } catch (e) {
      setError(connectionErrorHandler(e));
    }
  };

  const isApiKeyValid = !isEmptyString(apiKey);

  return (
    <CompoundConnectModal
      title="Connect Atlas"
      description="Access key is required to connect to Atlas."
      error={error}
      connectButtonDisabled={!isApiKeyValid}
      handleConnectWorkspace={handleConnectWorkspace}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Typo type="label2" weight="sb">
            Access key
          </Typo>
          <div
            className="flex items-center gap-1 cursor-pointer text-sm text-gray-600"
            onClick={() =>
              window.open(
                'https://developers.atlas.so/reference/getting-started-with-your-api',
              )
            }
          >
            How to get your Access key
            <InfoCircleOutlined className="text-primary size-3.5" />
          </div>
          <Input
            placeholder="type access key"
            sizeType="m"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
        </div>
      </div>
    </CompoundConnectModal>
  );
};
